/**
 * Created by brunopoeta on 12/06/17.
 */

import angular from 'angular';
import uiRouter from 'angular-ui-router';

// Controllers
import EventsController from './controllers/events.controller';

// Config
import RouteConfig from './index.route';

// Directives
import CardDirective from '../../directives/card.directive';
import SpinnerDirective from '../../directives/spinner.directive';
import ToolbarDirective from '../../directives/toolbar.directive';

// Filters
import SortFilter from '../../filters/sort.filter';

angular
    .module('events', [uiRouter])
    .config(['$compileProvider', function ($compileProvider) {
    	$compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|javascript):/);
    }])
    .config(['$stateProvider', '$locationProvider', '$urlRouterProvider', RouteConfig])
    .controller('EventsController', ['$http', '$sce', '$state', '$stateParams', '$timeout', EventsController])
    .directive('card', CardDirective)
    .directive('spinner', SpinnerDirective)
    .directive('toolbar', ToolbarDirective)
    .filter('sort', SortFilter);

angular
    .element(() => {
        angular.bootstrap(document, ['events']);
    });
